/**
 * §19 — Arayüz tamamen Türkçedir; kullanıcı hiçbir yerde ham enum görmemeli.
 *
 * Bu eşlemeler paylaşılan pakettedir çünkü aynı metinler hem tarayıcıda
 * (envanter tablosu) hem sunucuda (toplu işlem önizlemesi) üretiliyor.
 * İki kopya tutulsaydı biri güncellenip diğeri unutulurdu.
 */

export const PRODUCT_STATUS_LABELS = {
  ACTIVE: 'Aktif',
  INACTIVE: 'Pasif',
  AWAITING_SHIPPING_COST: 'Kargo bekliyor',
  PRICING_ERROR: 'Fiyat hatası',
  BLOCKED: 'Engelli',
  DELETED: 'Silindi',
  PENDING_UPLOAD: 'Yüklenecek',
} as const;

export type ProductStatusKey = keyof typeof PRODUCT_STATUS_LABELS;

/** Bilinmeyen bir durum gelirse ham değeri göster — sessizce boş bırakma. */
export function productStatusLabel(status: string): string {
  return PRODUCT_STATUS_LABELS[status as ProductStatusKey] ?? status;
}

/**
 * §11.8 — Amazon listeleme durumu.
 *
 * ⚠️ `NOT_FOUND` kullanıcıya "Amazon'da bulunamadı" diye gösteriliyor.
 * Kullanıcı 6 Eylül 2026'da sordu: *"NOT_FOUND Amazon'da olmayanlar demi"* —
 * çünkü süzgeç ham enum basıyordu ve tahmin etmek zorunda kaldı. Bu dosyanın
 * başındaki kural tam da bunu yasaklıyor.
 */
export const AMAZON_LISTING_STATUS_LABELS = {
  ACTIVE: 'Amazon’da satışta',
  INACTIVE: 'Amazon’da pasif',
  INCOMPLETE: 'Listeleme eksik',
  SUPPRESSED: 'Amazon bastırdı',
  NOT_FOUND: 'Amazon’da bulunamadı',
} as const;

export type AmazonListingStatusKey = keyof typeof AMAZON_LISTING_STATUS_LABELS;

export function amazonListingStatusLabel(status: string): string {
  return AMAZON_LISTING_STATUS_LABELS[status as AmazonListingStatusKey] ?? status;
}

/** Ürünün neden kapalı olduğu (`products.status_reason`). Serbest metin de gelebilir. */
export const STATUS_REASON_LABELS = {
  STALE_SOURCE_PROTECTION: 'Kaynak verisi doğrulanamadı (koruma)',
  SOURCE_UNREACHABLE: 'Kaynak verisi alınamıyor',
  SOURCE_OUT_OF_STOCK: 'Kaynakta stok yok',
  COMPETITOR_BELOW_MIN: 'Rakip fiyatı taban fiyatın altında',
  KISITLAMA_LISTESI: 'Kısıtlama listesine takıldı',
  ENVANTER_FILTRESI: 'Envanter filtresine takıldı',
  AWAITING_SHIPPING_COST: 'Kargo ücreti bekleniyor',
  PRICING_IMPOSSIBLE: 'Hedef marjla fiyat hesaplanamıyor',
} as const;

export type StatusReasonKey = keyof typeof STATUS_REASON_LABELS;

export function statusReasonLabel(reason: string): string {
  return STATUS_REASON_LABELS[reason as StatusReasonKey] ?? reason;
}

/** §9 — Kargo ücretinin nereden geldiği. */
export const SHIPPING_SOURCE_LABELS = {
  WAREHOUSE: 'Depo teklifi',
  // `shipping_costs.source` aynı kaynağa bu adı veriyor
  WAREHOUSE_FORM: 'Depo teklifi',
  FORMULA: 'Formülle tahmin',
  MANUAL: 'Elle girildi',
  EXCEL: 'Excel’den',
  NONE: 'Yok',
} as const;

export type ShippingSourceKey = keyof typeof SHIPPING_SOURCE_LABELS;

export function shippingSourceLabel(source: string): string {
  return SHIPPING_SOURCE_LABELS[source as ShippingSourceKey] ?? source;
}
